import React from "react";
import "./SideDrawer.scss";
import { NavLink } from "react-router-dom";
import { options, prodavnicaKategorije } from "../../../shared/shared";

export default function SideDrawer({ show, clicked }) {
  return (
    <nav className={`side-drawer ${show ? "open" : ""}`}>
      <div className="side-drawer__header">
        <NavLink to="/" className="side-drawer__logo" onClick={clicked}>
          IKONE<b>.RS</b>
        </NavLink>
        <button className="side-drawer__close" onClick={clicked} aria-label="Zatvori meni">✕</button>
      </div>

      <div className="side-drawer__section">
        <p className="side-drawer__section-label">Kategorije ikona</p>
        <ul>
          {prodavnicaKategorije.map((kat, i) => (
            <li key={i}>
              <NavLink to={`/prodavnica`} className="side-drawer__link side-drawer__link--cat" onClick={clicked}>
                {kat.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      <div className="side-drawer__divider" />

      <div className="side-drawer__section">
        <p className="side-drawer__section-label">Ostalo</p>
        <ul>
          {options.slice(1).map((option, i) => (
            <li key={i}>
              <NavLink to={option.route} className="side-drawer__link" onClick={clicked}>
                {option.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
